var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"c-label c:row-start-center",attrs:{"for":_vm.labelFor}},[_c('div',{attrs:{"id":"c-label"}},[_vm._t("default")],2),(_vm.required)?_c('img',{staticClass:"required-icon",attrs:{"src":require("@/assets/icons/required.svg"),"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }